import type { CollectionType, QueryItem } from '@directus/sdk';
import type {
  CustomDirectusTypes,
  DirectusFiles,
  DirectusRoles,
  DirectusUsers,
} from '@funnellab/shared/src/types/directus.ts';

export type DirectusUserDto = Required<
  Pick<
    DirectusUsers,
    | 'id'
    | 'first_name'
    | 'last_name'
    | 'email'
    | 'gender'
    | 'language'
    | 'applicationNotification'
    | 'jobNoteNotification'
  >
> & {
  avatar: Pick<DirectusFiles, 'id' | 'title' | 'filename_disk'> | null;
  role: Pick<DirectusRoles, 'name'>;
};

export const directusUsersQuery = {
  fields: [
    'id',
    'first_name',
    'last_name',
    'email',
    'phone',
    'gender',
    'language',
    'applicationNotification',
    'jobNoteNotification',
    {
      role: ['name'],
      avatar: ['id', 'title', 'filename_disk'],
    },
  ],
} as const satisfies QueryItem<
  CustomDirectusTypes,
  CollectionType<CustomDirectusTypes, 'directus_users'>
>;
